
module.exports = function (state) {
    return {
      // 'vendors/reset-css': state.FURTHER_REF + 'reset-css/reset.css',
      'vendors/babel-polifills': [
        state.FURTHER_REF + 'core-js/es6/function',
        state.FURTHER_REF + 'core-js/es6/map',
        state.FURTHER_REF + 'core-js/es6/math',
        state.FURTHER_REF + 'core-js/es6/number',
        state.FURTHER_REF + 'core-js/es6/object',
        state.FURTHER_REF + 'core-js/es6/regexp',
        state.FURTHER_REF + 'core-js/es6/string',
        state.FURTHER_REF + 'core-js/fn/array/includes'
      ],
    // 'react': ['preact-compat'],

//       // // 'babel-polyfill': 'babel-polyfill',
//       // // 'core-js': 'core-js',
//       // // 'core-js/es6/array': 'core-js/es6/array',
    
//       // 'vendors/core-js/es6/function': 'core-js/es6/function',
//       // 'vendors/core-js/es6/map': 'core-js/es6/map',
//       // 'vendors/core-js/es6/math': 'core-js/es6/math',
//       // 'vendors/core-js/es6/number': 'core-js/es6/number',
//       // 'vendors/core-js/es6/object': 'core-js/es6/object',
//       // // 'core-js/es6/promise': 'core-js/es6/promise',
//       // 'vendors/core-js/es6/regexp': 'core-js/es6/regexp',
//       // 'vendors/core-js/es6/string': 'core-js/es6/string',
//       // 'vendors/core-js/fn/array/includes': 'core-js/fn/array/includes',
//    'vendors/webpack-hot-middleware/client': 'webpack-hot-middleware/client',
    'main/index': `${state.SRC_PATH}/client/main/`,
  }
}


// WEBPACK FOOTER //
// ./src/technologies/entries.js